<template>
	<div
		v-if="summary"
		class="d-flex flex-column justify-space-between align-center"
		style="height: 100%"
	>
		<SiteScannerSummaryCard
			:current-scan="currentScan.summary.pagesScanned"
			:previous-scan="safePreviousPages"
			card-label="Pages scanned"
		/>
		<SiteScannerSummaryCard
			:current-scan="currentScan.firstParty"
			:previous-scan="safeFirstParty"
			card-label="First party"
		/>
		<SiteScannerSummaryCard
			:current-scan="currentScan.thirdParty"
			:previous-scan="safeThirdParty"
			card-label="Third party"
		/>
		<SiteScannerSummaryCard
			:current-scan="formattedTimeTaken"
			:previous-scan="formattedPreviousTimeTaken"
			card-label="Time taken"
		/>
	</div>
</template>

<script>
import SiteScannerSummaryCard from './site-scanner-summary-card.vue'

export default {
	components: {
		SiteScannerSummaryCard
	},
	props: {
		summary: {
			type: Object
		}
	},
	computed: {
		previousScan () {
			return this.summary.previousScan ?? null
		},
		currentScan () {
			return this.summary.currentScan
		},
		safePreviousPages () {
			return this.previousScan?.summary.pagesScanned ?? 0
		},
		safeFirstParty () {
			return this.previousScan?.firstParty ?? 0
		},
		safeThirdParty () {
			return this.previousScan?.thirdParty ?? 0
		},
		formattedTimeTaken () {
			return this.formatTimeTaken(this.currentScan?.summary.timeTakenSeconds ?? 0)
		},
		formattedPreviousTimeTaken () {
			if (!this.summary.previousScan) {
				return null
			}
			return this.formatTimeTaken(this.previousScan?.summary.timeTakenSeconds ?? 0)
		}
	},
	methods: {
		formatTimeTaken (timeSeconds) {
			const hours = Math.floor(timeSeconds / 3600)
			const minutes = Math.floor((timeSeconds / 60) % 60)
			const seconds = Math.floor(timeSeconds % 60)
			const paddedSeconds = seconds.toString().padStart(2, '0')
			const paddedMinutes = minutes.toString().padStart(2, '0')
			const paddedHours = hours.toString().padStart(2, '0')
			return hours === 0 ? `${paddedMinutes}:${paddedSeconds}` : `${paddedHours}:${paddedMinutes}:${paddedSeconds}`
		}
	}
}
</script>
